  <template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel"
           @on-visible-change="visiableChange" :width="660">
      <h3 slot="header" class="modal-header">{{updateUid?'修改用户':'添加用户'}}</h3>
      <div class="mb16" style="padding-left: 20px" v-if="!updateUid">
<!--        <a href="javascript:void(0)" @click.stop="addEmploye" v-p="{api:'user/addZiroomEmployee'}">{{'点我添加自如员工'}}</a>-->
      </div>

      <div>
        <Form :model="formData" :label-width="90" :rules="formRules"  ref="formData">
          <Row>
            <Col span="12">
              <FormItem label="姓名" prop="nickName">
                <Input v-model="formData.nickName"></Input>
                <Input   class="item-width" v-model="formData.uid" style="display: none"></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="密码">
                <span class="error-color">账号创建成功后，默认密码123456</span>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="手机号" prop="phone">
                <Input :disabled="updateUid?true:false" v-model="formData.phone"></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="性别" prop="sex">
                <Select placeholder="请选择" v-model="formData.sex">
                  <Option v-for="item in sexList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="籍贯" prop="hometown">
                <Input v-model="formData.hometown"></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="身份证号" prop="certificateCode">
                <Input v-model="formData.certificateCode"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="所属项目" prop="projectFid">
                <Select placeholder="请选择" v-model="formData.projectFid">
                  <Option v-for="item in projectOptions" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="职位" prop="position">
                <Select placeholder="请选择" v-model="formData.position">
                  <Option v-for="item in positionOptions" :value="item.value" :key="item.value">{{item.name}}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="入职时间" prop="entryTime">
                <Date-picker type="date" v-model="formData.entryTime" placeholder="选择日期" format="yyyy-MM-dd" ></Date-picker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="所属机构" class="ivu-form-item-required">
                <a href="javascript:void(0)" @click.stop="addOrg">{{titleArr.length > 0?titleArr:'添加组织机构'}}</a>
              </FormItem>
            </Col>
<!--            <Col span="12">-->
<!--              <FormItem label="系统角色" class="ivu-form-item-required">-->
<!--                <a href="javascript:void(0)" @click.stop="addChara(1)">{{roleNameArr.length > 0?roleNameArr:'添加盘古系统角色'}}</a>-->
<!--              </FormItem>-->
<!--            </Col>-->
            <Col span="12">
              <FormItem label="系统角色" class="ivu-form-item-required">
                <a href="javascript:void(0)" @click.stop="addChara(3)">{{newroleNameArr.length > 0?newroleNameArr:'添加系统角色'}}</a>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <!--<Col span="12">-->
              <!--<FormItem label="超级zo角色">-->
                <!--<a href="javascript:void(0)" @click.stop="addChara(2)">{{zoRoleNameArr.length > 0?zoRoleNameArr:'添加超级zo角色'}}</a>-->
              <!--</FormItem>-->
            <!--</Col>-->
            <!--<Col span="12">-->
              <!--<FormItem label="marketing角色">-->
                <!--<a href="javascript:void(0)" @click.stop="addChara(4)">{{marketingRoleNameArr.length > 0?marketingRoleNameArr:'添加marketing系统角色'}}</a>-->
              <!--</FormItem>-->
            <!--</Col>-->
<!--            <Col span="12">-->
<!--              <FormItem label="新自如寓角色">-->
<!--                <a href="javascript:void(0)" @click.stop="addChara(3)">{{newroleNameArr.length > 0?newroleNameArr:'添加新自如寓系统角色'}}</a>-->
<!--              </FormItem>-->
<!--            </Col>-->
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="备注">
                <Input v-model="formData.remark"></Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
        <add-employ :n="emplyN" :positionOptions="positionOptions" @setTitleValueArr="setTitleValueArr" @done="done"></add-employ>
        <add-org :n="orgN" :valueArrStr="valueArr" @setTitleValueArr="setTitleValueArr"></add-org>
        <CharacterList :n="charaN" :roleIdArrStr="allRoleValueArr" :appType="formData.appType" @getRole="getRoles"></CharacterList>

      </div>
    </Modal>
  </div>


</template>
<script>
  import AddOrg from './AddOrg'
  import AddEmploy from './AddEmploy.vue'
  import CharacterList from './CharacterList'
  import {addUser, getUserDetail, updateUser, getAllProject} from "../../../../api/user";
  import {getBaseUrl} from "utils/public";
  import {getToken} from "utils/auth";
  import {formatDateTime} from "utils/format";

  export default {
    name: "",
    components: {
      AddOrg,
      CharacterList,
      AddEmploy
    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      updateUid:{
        type:String,
        default:''
      },
      positionOptions: {
        type: Array,
        default: () => []
      }
    },
    watch: {
      n() {
        // this.data=null
        this.clearData();
        this.isShow = true;
        this.initData(this.updateUid);
        this.getProjectOpt()
      }
    },
    data() {
      const validateEmail = (rule, value, callback) => {
        const pattern = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        if(!pattern.test(value)){
          callback(new Error('输入正确的邮箱'));
        } else{
          callback();
        }
      };
      const validateDate = (rules,value,callback)=>{
        rules.type = typeof value === 'object' ? 'object':'string'
        if(!value){
          callback(new Error('请选择入职时间'));
        }
        callback();
      }

      return {
        charaN: 0,
        charaZO: 0,
        orgN: 0,
        emplyN: 0,
        titleArr:'',
        valueArr:'',
        allRoleValueArr:'',
        roleValueArr:'',
        roleNameArr:'',
        newroleValueArr:'',
        newroleNameArr:'',
        zoRoleValueArr:'',
        zoRoleNameArr:'',
        marketingRoleValueArr:'',
        marketingRoleNameArr:'',
        loading: true,
        isShow: false,
        sexList:[{text:'男',value:1},{text:'女',value:2}],
        projectOptions:[],
        formData: {
          marketingRoleIds:'',
          newRoleIds:'',
          uid:'',
          nickName: '',
          phone: '',
          sex: null,
          hometown:'',
          certificateCode:'',
          entryTime:'',
          // email: '',
          position: '',
          projectFid:'',
          remark: '',
          organUids:'',
          roleIds:'',
          zoRoleIds:'',
          appType:1,
        },
        formRules: {
          nickName: [{required: true, message: ' ', trigger: 'blur', type: 'string'}],
          phone: [{required: true, validator: this.validatecontactPhone, trigger: 'change', message: '请填写正确的手机号'}],
          sex: [{required: true, message: ' ', trigger: 'change', validator: this.validateNumber}],
          hometown: [{required: true, message: ' ', trigger: 'blur', type: 'string'}],
          certificateCode: [{required: true, validator: this.validatecontactCertNum, trigger: 'change', message: '请填写正确身份证号'}],
          entryTime:[{ required: true, message: '*' ,trigger: 'change', type:'date', validator: validateDate}],
          // email: [{required:true, validator:validateEmail, trigger:'blur' }],
          position: [{ required: true, message: '请选择职位信息', trigger: 'change' }],
          projectFid: [{ required: true, message: '请选择所属项目', trigger: 'change' }]
        },
        token: '',
        baseUrl: '',
        // data:null,
        projectHeadImg:''
      }
    },
    methods: {
      format(data, showTime = false) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, showTime)
      },
      handleSuccess(response){
        this.projectHeadImg = response.data.url
      },
      handleError(){

      },
      formatError(){
        this.$Message.info('请上传图片类型文件')
      },
      clearData(){
        this.formData={
          nickName: '',
          phone: '',
          sex: null,
          hometown:'',
          certificateCode:'',
          entryTime:'',
          // email: '',
          position: '',
          projectFid:'',
          remark: '',
          organUids:'',
          roleIds:'',
          zoRoleIds:'',
          newRoleIds:'',
        };
        this.titleArr='';
        this.valueArr='';
        this.roleValueArr='';
        this.roleNameArr='';
        this.zoRoleValueArr='';
        this.zoRoleNameArr='';
        this.marketingRoleValueArr='';
        this.marketingRoleNameArr='';
        this.allRoleValueArr='';
        this.newroleNameArr='';
        this.newroleValueArr=''
        this.$refs['formData'] &&  this.$refs['formData'].resetFields()
      },
      addChara(params) {
        this.allRoleValueArr='';
        if(params === 1){
          this.allRoleValueArr = this.roleValueArr
        }
        if(params === 2){
          this.allRoleValueArr = this.zoRoleValueArr
        }
        if(params===3){
          this.allRoleValueArr = this.newroleValueArr

        }
        if(params===4){
          this.allRoleValueArr = this.marketingRoleValueArr

        }
        this.formData.appType = params
        this.charaN++
      },
      addOrg() {
        this.orgN++
      },
      addEmploye() {
        this.emplyN++;
        this.isShow = false
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        if(!this.valueArr){
          this.$Message.info('请添加组织机构！');
          this.changeLoading();
          return
        }
        if(!this.newroleNameArr){
          this.$Message.info('请添加系统角色！');
          this.changeLoading();
          return
        }
        this.$refs['formData'].validate(bool => {
          if (bool) {
            this.formData.organUids = this.valueArr;
            this.formData.roleIds = this.roleValueArr;
            this.formData.zoRoleIds = this.zoRoleValueArr;
            this.formData.newRoleIds=this.newroleValueArr;
            this.formData.marketingRoleIds=this.marketingRoleValueArr;
            if(!this.updateUid){
              addUser(this.formData).then(res=>{
                this.$Message.success('添加用户成功');
                this.$emit('done')

              }).catch(error=>{

              }).finally(()=>{
                this.isShow=false
              })
            }else {
              updateUser(this.formData).then(res=>{
                this.$Message.success('修改用户成功');
                this.$emit('done')
              }).catch(error=>{

              }).finally(()=>{
                this.isShow=false
              })
            }
          }
          else {
            this.changeLoading()
          }
        })
      },
      done(){
        this.$emit('done')
      },
      cancel() {
        this.isShow = false
      },
      validateNumber(rule, value, callback) {
        const pattern = /^\d+$/;
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      validatecontactPhone(rule, value, callback) {
        const pattern = /^1(\d+){10}$/;
        if (!pattern.test(value)) {
          callback(new Error('输入正确的联系方式'));
        }
        callback();
      },
      validatecontactCertNum(rule, value, callback) {
        const pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!pattern.test(value)) {
          callback(new Error('输入正确的身份证号'));
        } else {
          callback();
        }
      },
      setTitleValueArr(params){

        const title=[];
        const value=[];
        params.forEach(ele=>{
          title.push(ele.title);
          value.push(ele.value)

        });
        this.titleArr = title.join(',');
        this.valueArr = value.join(',')
      },
      getRoles(params) {
        if(params.appType === 1){
          this.roleValueArr = params.roleValueArr.join(',');
          this.roleNameArr = params.roleNameArr.join(',')
          return
        }
        if(params.appType === 2){
          this.zoRoleValueArr = params.roleValueArr.join(',');
          this.zoRoleNameArr = params.roleNameArr.join(',')
          return
        }
        if(params.appType === 3){
          this.newroleValueArr = params.roleValueArr.join(',');
          this.newroleNameArr = params.roleNameArr.join(',')
          return
        }
        if(params.appType === 4){
          this.marketingRoleValueArr = params.roleValueArr.join(',');
          this.marketingRoleNameArr = params.roleNameArr.join(',')
          return
        }
      },
      initData(updateUid) {
        if(updateUid){
          getUserDetail({uid: updateUid}).then(res => {
            if(!res.data){
              return

            }
            // this.formData=res.data
            const data=res.data
            this.formData.uid = data.uid;
            this.formData.nickName = data.nickName;
            this.formData.phone = data.phone;
            this.formData.sex = data.sex;
            this.formData.hometown = data.hometown;
            this.formData.certificateCode = data.certificateCode;
            this.formData.entryTime = this.format(data.entryTime);
            // this.formData.email = data.email;
            this.formData.position = data.position;
            this.formData.projectFid = data.projectFid;
            this.formData.remark = data.remark;
            this.titleArr = data.organNames?data.organNames.join(','):'';
            this.valueArr = data.organUids?data.organUids.join(','):'';
            this.roleValueArr = data.roleIds?data.roleIds.join(','):'';
            this.roleNameArr = data.roleNames ?data.roleNames.join(','):''
            this.zoRoleValueArr =data.zoRoleIds ? data.zoRoleIds.join(','):'';
            this.zoRoleNameArr =data.zoRoleNames? data.zoRoleNames.join(','):'';
            this.marketingRoleValueArr =data.marketingRoleIds ? data.marketingRoleIds.join(','):'';
            this.marketingRoleNameArr =data.markeingRoleNames? data.markeingRoleNames.join(','):''

            data.newRoleIds && (  this.newroleValueArr=data.newRoleIds.join(','))
            data.newRoleNames && (  this.newroleNameArr=data.newRoleNames.join(','))
          }).catch(res=> {
          })
        }
      },
      getProjectOpt(){
        getAllProject({}).then(res=>{
          this.projectOptions = res.data;
        }).catch(error=>{

        })
      },
      visiableChange(value){
        if(!value){
          this.$emit('close')
        }
      },
    },
    created(){
      // this.getProjectConfigInfo()
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }
  }
</script>

<style scoped>
  .item-width {
    width: 280px;
  }
  .imgwidth{
    width: 150px;
    height: 100px;
    vertical-align: middle;
  }
  .upload {
    display: inline-block;
    width: 150px;
    height: 100px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 100px;
    vertical-align: middle;
  }

</style>
